// extracted by mini-css-extract-plugin
module.exports = {"heading":"Approvers_heading__3Iqdu","mainHeadline":"Approvers_mainHeadline__3bbed","mainContentTitle":"Approvers_mainContentTitle__2ofFU"};